import {
  RowNumberDataReport,
  RowNumberDataReportAlignCenter,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import {
  DateFormat,
  arrayIntoString,
  degreeListConvertionPart,
} from 'modules/Report/CommonFunction/Function.js'
import { ApplicationDriveTitle } from 'modules/Report/ExcelHeaderData.js'
import PageContent from 'modules/Report/Partials/CommonTable/PageContent.js'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import WarningMessage from 'utils/WarningMessage'
import { permittedSubEvents } from '../../../../utils/permissionsValidation'
import { serialNo } from '../../CommonFunction/Function'
import { setApplicationDriveLeve } from '../../action'
const ApplicationDriveStatus = ({
  cityData,
  cityDetails,
  tierDetails,
  tierData,
  getApplicationDriveLevel,
  rolesPublishedData,
  excelDataForReport,
  collegeDetails,
  roleDetails,
  collegeData,
  roleData,
  roundDetails,
  courseTypeDetails,
  roundData,
  courseTypeData,
  getListOfDegree,
  listOfDegree,
  degreeDetails,
  degreeData,
  corporateData,
  statusDetails,
  statusData,
}) => {
  const dispatch = useDispatch()
  const [currentPage, setCurrentPage] = useState(1)
  const [loadingDep, setLoadingDep] = useState(false)
  const [excelLoading, setExcelLoading] = useState(false)
  const [loadingTier, setLoadingTier] = useState(false)
  const [loadingRole, setLoadingRole] = useState(false)
  const [loadingRound, setLoadingRound] = useState(false)
  const [loadingStatus, setLoadingStatus] = useState(false)
  const [loadingType, setLoadingType] = useState(false)
  const [loadingRoleFilter, setLoadingRoleFilter] = useState(false)
  const [loadingCollegeFilter, setLoadingCollegeFilter] = useState(false)
  const [searchTierValue, setSearchTierValue] = useState('')
  const [searchRoleValue, setSearchRoleValue] = useState('')
  const [searchRoundValue, setSearchRoundValue] = useState('')
  const [searchStatusValue, setSearchStatusValue] = useState('')
  const [searchCollegeValue, setSearchCollegeValue] = useState('')
  const [searchDegree, setSearchDegree] = useState('')
  const [tierValue, setTierValue] = useState([])
  const [cityValue, setCityValue] = useState([])
  const [roleValue, setRoleValue] = useState([])
  const [roundValue, setRoundValue] = useState([])
  const [statusValue, setStatusValue] = useState([])
  const [typeValue, setTypeValue] = useState([])
  const [collegeValue, setCollegeValue] = useState([])
  const [debounced, setDebounced] = useState(() => roleNameValue)
  const [debouncedDegree, setDebouncedDegree] = useState(() => searchDegree)
  const [createdAtStart, setCreatedAtStart] = useState('')
  const [filterCancel, setFilterCancel] = useState(false)
  const [offerRaisedFilter, setOfferRaisedFilter] = useState('')
  const [offerAppliedFilter, setOfferAppliedFilter] = useState('')
  const [lastDate, setLastDate] = useState('')
  const [createdAtEnd, setCreatedAtEnd] = useState('')
  const [appendDateFilter, setAppendDateFilter] = useState([])
  const [clearDate, setClearDate] = useState(false)
  const [searchCourseType, setSearchCourseType] = useState('')
  const [roleNameValue, setRoleNameValue] = useState()
  const [clear, setClear] = useState(false)
  const [error, setError] = useState('')
  const [rank, setRank] = useState('')
  const [rankSign, setRankSign] = useState('')
  const [dateError, setDateError] = useState(false)
  const [filterData, setFilterData] = useState({
    tier: '',
    job: '',
    college: '',
    createdAtEnd: '',
    createdAtStart: '',
    appenddate: '',
    offered: '',
    accepted: '',
    rank: '',
    rankSign: '',
    round: '',
    type: '',
  })
  const [searchQuery, setSearchQuery] = useState('')
  const [degreeLoader, setDegreeLoader] = useState(false)
  const [page, setPage] = useState(0)
  const [count, setCount] = useState(0)
  useEffect(() => {
    dispatch(setApplicationDriveLeve())
  }, [])
  useEffect(() => {
    setPage(0)
    degreeDetails(setLoadingDep, searchDegree, setDegreeLoader, 0)
  }, [debouncedDegree])
  const loadMoreData = async () => {
    degreeDetails(
      setLoadingDep,
      searchDegree,
      setDegreeLoader,
      degreeData?.page + 1
    )
    setPage(page + 1)
  }
  const handleSearch = e => {
    const query = e.target.value
    setSearchQuery(query)
  }
  const [degreeListData, setDegreeListData] = useState([])
  const [tooltip, setTooltip] = useState(false)
  const [sortBy, setSortBy] = useState({
    orderBy: 'desc',
    sortName: 'c.start_date',
  })
  const [isExcel, setIsExcel] = useState('')
  const [excel, setExcel] = useState([])
  const [degreeList, setDegreeList] = useState([])
  const [previousPage, setPreviousPage] = useState('')
  const onPageChange = pageNum => {
    setPreviousPage(currentPage)
    setCurrentPage(pageNum)
  }
  function hasData(obj) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] !== '') {
        return true
      }
    }
    return false
  }
  useEffect(() => {
    getListOfDegree({})
  }, [])
  function toCamelCase(str) {
    const words = str.split(' ')
    const camelCaseWords = words.map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
    return camelCaseWords.join(' ')
  }
  useEffect(() => {
    const updatedData = degreeListConvertionPart({
      listOfDegree: degreeData?.result,
      selectedIds: [],
      isEditActiveRole: [],
    })
    setCount(degreeData?.count)
    setDegreeListData(updatedData)
  }, [degreeData])
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebounced(roleNameValue)
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [roleNameValue])
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedDegree(searchDegree)
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [searchDegree])
  const clearFilter = () => {
    setCityValue([])
    setStatusValue([])
    setRoundValue([])
    setSearchTierValue('')
    setSearchRoleValue('')
    setSearchCourseType('')
    setSearchCollegeValue('')
    setTierValue([])
    setCollegeValue([])
    setRoleValue([])
    setCreatedAtStart('')
    setCreatedAtEnd('')
    setRoleNameValue('')
    setLastDate('')
    setClearDate(true)
    setClear(true)
    setRank('')
    setRankSign('')
    setDegreeList([])
    setRoundValue([])
    setTypeValue([])
    setSearchQuery('')
    setSearchRoundValue('')
    dispatch(setApplicationDriveLeve())
    setFilterData({ tier: '', city: '' })
    setFilterCancel(true)
  }
  const applyFilter = () => {
    let filterData = {
      tier: arrayIntoString(tierValue),
      college: arrayIntoString(collegeValue),
      role: arrayIntoString(roleValue),
      createdAtStart: createdAtStart,
      createdAtEnd: createdAtEnd,
      appenddate: lastDate,
      offered: arrayIntoString(offerRaisedFilter),
      accepted: arrayIntoString(offerAppliedFilter),
      rank: rank,
      rankSign: rankSign,
      status: arrayIntoString(statusValue),
      round: arrayIntoString(roundValue),
      type: arrayIntoString(typeValue),
      degreeStreamMapId: arrayIntoString(degreeList),
    }
    if (createdAtStart) {
      if (!createdAtEnd) {
        WarningMessage(
          <>
            Kindly select <q>To Date</q> from Date Range
          </>
        )
      }
    }
    if (createdAtEnd) {
      if (!createdAtStart) {
        WarningMessage(
          <>
            Kindly select <q>From date</q> from Date Range
          </>
        )
      }
    }
    if (createdAtEnd && createdAtStart && error == '' && !dateError) {
      setFilterData(filterData)
    }
    if (!createdAtEnd && !createdAtStart && error == '' && !dateError) {
      setFilterData(filterData)
    }
    if (error || dateError) {
      WarningMessage(<>Kindly check the error in filter</>)
    }
  }
  useEffect(() => {
    if (error !== '' || dateError) {
      setTooltip(true)
    }
  }, [error, dateError])
  const tableData = excelDataForReport?.result?.map((item, index) => [
    {
      value: index + 1,
    },
    { value: item.start_date ? DateFormat(item.start_date) : '-' },
    {
      value: item.first_name
        ? item.first_name +
          (item.last_name ? ' ' + String(item.last_name).trim() : '')
        : '-',
    },
    { value: item.campus_name ? toCamelCase(item.campus_name) : '-' },
    { value: item.degree ? toCamelCase(item.degree) : '-' },
    { value: item.tier ? item.tier : '0' },
    { value: item.serial_no ? item.serial_no : '0' },
    { value: item.tittle ? toCamelCase(item.tittle) : '-' },
    { value: item.rating ? Number(Number(item.rating)?.toFixed(2)) : '0' },
    {
      value: item.interview_round__type
        ? item.interview_round__type
            ?.split('_')
            ?.map(
              word =>
                word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
            )
            ?.join(' ')
        : '-',
    },
    { value: item.status ? toCamelCase(item.status) : '-' },
  ])
  const excelData = [{ columns: ApplicationDriveTitle, data: tableData }]
  const onSorting = (pagination, row, sorter) => {
    let order = 'desc'
    let sort = sorter.field
    if (sorter.order === 'descend') {
      //
    } else if (sorter.order === 'ascend') {
      order = 'asc'
    } else {
      sort = 'c.start_date'
    }
    let sortBy = {
      orderBy: order,
      sortName: sort,
    }
    setSortBy(sortBy)
  }
  useEffect(() => {
    if (hasData(filterData)) {
      if (currentPage) {
        if (hasData(filterData))
          getApplicationDriveLevel(
            10,
            currentPage,
            setLoadingRole,
            roleNameValue,
            filterData,
            sortBy
          )
      }
    }
  }, [currentPage])
  useEffect(() => {
    if (hasData(filterData))
      getApplicationDriveLevel(
        10,
        1,
        setLoadingRole,
        roleNameValue,
        filterData,
        sortBy
      )
    setCurrentPage(1)
  }, [filterData, debounced, sortBy])
  useEffect(() => {
    setTierValue([])
  }, [])
  useEffect(() => {
    let filterData = {
      tier: arrayIntoString(tierValue),
      round: arrayIntoString(roundValue),
      type: arrayIntoString(typeValue),
      city: arrayIntoString(cityValue),
      college: arrayIntoString(collegeValue),
      role: arrayIntoString(roleValue),
      status: arrayIntoString(statusValue),
      createAtStart: createdAtStart,
      createAtEnd: createdAtEnd,
      appenddate: lastDate,
      offered: arrayIntoString(offerRaisedFilter),
      accepted: arrayIntoString(offerAppliedFilter),
      degreeStreamMapId: arrayIntoString(degreeList),
      rank: rank,
      rankSign: rankSign,
    }
    setTooltip(hasData(filterData))
  }, [
    statusValue,
    tierValue,
    cityValue,
    collegeValue,
    roleValue,
    createdAtStart,
    createdAtEnd,
    lastDate,
    offerAppliedFilter,
    offerAppliedFilter,
    rank,
    rankSign,
    roundValue,
    typeValue,
    degreeList,
    error,
    dateError,
    clear,
    clearDate,
  ])

  const columns = [
    {
      title: 'SR. NO',
      dataIndex: 'id',
      width: '5%',
      align: 'center',
      render: (text, record, index) => (
        <RowNumberDataReportAlignCenter>
          {serialNo(index, previousPage, currentPage, loadingRole)}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'drive date',
      width: '10%',
      dataIndex: 'c.start_date',
      sorter: true,
      align: 'center',
      render: (_, { start_date }) => (
        <RowNumberDataReportAlignCenter>
          {DateFormat(start_date)}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'Student name',
      dataIndex: 'd.first_name',
      sorter: true,
      render: (_, { first_name, last_name }) => (
        <RowNumberDataReport>
          {' '}
          {first_name + (last_name ? ' ' + String(last_name).trim() : '')}
        </RowNumberDataReport>
      ),
    },
    {
      title: 'college name',
      sorter: true,
      dataIndex: 'f.campus_name',
      render: (_, { campus_name }) => (
        <RowNumberDataReport>{toCamelCase(campus_name)}</RowNumberDataReport>
      ),
    },
    {
      title: 'degree',
      dataIndex: 'e.degree',
      sorter: true,
      render: (_, { degree, short_form }) => (
        <RowNumberDataReport>
          {short_form
            ? short_form + ' - ' + toCamelCase(degree)
            : toCamelCase(degree)}
        </RowNumberDataReport>
      ),
    },
    {
      title: 'tier',
      dataIndex: 'g.tier',
      sorter: true,
      align: 'center',
      render: (_, { tier }) => (
        <RowNumberDataReportAlignCenter>{tier}</RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'drive Number',
      dataIndex: 'c.serial_no',
      key: 'c.serial_no',
      sorter: true,
      align: 'center',
      render: (_, { serial_no }) => (
        <RowNumberDataReportAlignCenter>
          {serial_no}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'role',
      dataIndex: 'h.tittle',
      key: 'h.tittle',
      sorter: true,
      render: (_, { tittle }) => (
        <RowNumberDataReport>{tittle}</RowNumberDataReport>
      ),
    },
    {
      title: 'rank',
      dataIndex: 'i.rating',
      key: 'i.rating',
      sorter: true,
      align: 'center',
      render: (_, { rating }) => (
        <RowNumberDataReportAlignCenter>
          {Number(rating)?.toFixed(2)}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'Round',
      dataIndex: 'a.interview_round__type',
      key: 'a.interview_round__type',
      sorter: true,
      render: (_, { interview_round__type }) => (
        <RowNumberDataReport>
          {interview_round__type
            ?.split('_')
            ?.map(
              word =>
                word?.charAt(0)?.toUpperCase() + word.slice(1)?.toLowerCase()
            )
            ?.join(' ')}
        </RowNumberDataReport>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'a.status',
      key: 'a.status',
      sorter: true,
      render: (_, { status }) => (
        <RowNumberDataReport>
          {status?.charAt(0)?.toUpperCase() + status?.slice(1)?.toLowerCase()}
        </RowNumberDataReport>
      ),
    },
  ].filter(item => !item.hidden)
  const clickedExcel = data => {
    let excel = true
    getApplicationDriveLevel(
      5000,
      1,
      setExcelLoading,
      roleNameValue,
      filterData,
      sortBy,
      excel
    )
    setIsExcel(data)
  }

  useEffect(() => {
    if (
      (excelDataForReport?.result && tableData && isExcel == 'excel') ||
      (excelDataForReport?.result && tableData && isExcel == 'pdf')
    ) {
      if (loadingRole) {
        setExcel([])
      } else {
        setExcel(excelData)
      }
    }
  }, [excelDataForReport?.result, loadingRole])
  const handleHover = () => {
    if (rolesPublishedData?.count > 5000) {
      WarningMessage(
        'Note : The Applicants At Drive Level count should not exceed 5,000 for data export.  Apply filters if necessary'
      )
    }
  }
  const dataSign = data => {
    setRankSign(data.rankSign)
    setRank(data.rank)
  }
  const FilterData = [
    {
      id: 7,
      headerName: 'Degree & Department',
      searchValue: searchQuery,
      setSearchValue: setSearchQuery,
      data: degreeListData,
      setLoading: setLoadingTier,
      loading: loadingDep,
      valueParam: 'tier',
      labelParam: 'tier',
      divider: false,
      onChange: handleSearch,
      searchQuery: searchQuery,
      degree: degreeList,
    },
    {
      id: 8,
      headerName: 'Course Type',
      searchValue: searchCourseType,
      setSearchValue: setSearchCourseType,
      setValue: setTypeValue,
      value: typeValue,
      data: courseTypeData,
      apicall: courseTypeDetails,
      setLoading: setLoadingType,
      loading: loadingType,
      valueParam: 'education_level_value',
      labelParam: 'education_level',
      divider: false,
    },
    {
      id: 2,
      headerName: 'College Name',
      searchValue: searchCollegeValue,
      setSearchValue: setSearchCollegeValue,
      setValue: setCollegeValue,
      value: collegeValue,
      data: collegeData,
      apicall: collegeDetails,
      setLoading: setLoadingCollegeFilter,
      loading: loadingCollegeFilter,
      valueParam: 'id',
      labelParam: 'campus_name',
      flag: 'AD',
      divider: false,
    },
    {
      id: 3,
      headerName: 'Role',
      searchValue: searchRoleValue,
      setSearchValue: setSearchRoleValue,
      setValue: setRoleValue,
      value: roleValue,
      data: roleData,
      apicall: roleDetails,
      setLoading: setLoadingRoleFilter,
      loading: loadingRoleFilter,
      valueParam: 'id',
      labelParam: 'tittle',
      divider: false,
      flag: 'AD',
    },
    {
      id: 4,
      headerName: 'College Tier',
      searchValue: searchTierValue,
      setSearchValue: setSearchTierValue,
      setValue: setTierValue,
      value: tierValue,
      data: tierData,
      apicall: tierDetails,
      setLoading: setLoadingTier,
      loading: loadingTier,
      valueParam: 'tier',
      labelParam: 'tier',
      divider: false,
      flag: 'AD',
    },
    {
      id: 7,
      headerName: 'Round',
      setValue: setRoundValue,
      setSearchValue: setSearchRoundValue,
      searchValue: searchRoundValue,
      value: roundValue,
      data: roundData,
      apicall: roundDetails,
      setLoading: setLoadingRound,
      loading: loadingRound,
      valueParam: 'interview_round__type',
      labelParam: 'interview_round__type',
      divider: false,
    },
    {
      id: 41,
      headerName: 'Status',
      setValue: setStatusValue,
      setSearchValue: setSearchStatusValue,
      searchValue: searchStatusValue,
      value: statusValue,
      data: statusData,
      apicall: statusDetails,
      setLoading: setLoadingStatus,
      loading: loadingStatus,
      valueParam: 'status',
      labelParam: 'status',
      divider: false,
    },
    {
      id: 6,
      headerName: 'Rank',
      setRank: setRank,
      setRankSign: setRankSign,
      divider: false,
    },
    {
      id: 1,
      headerName: 'Date Range',
      setCreatedAtStart: setCreatedAtStart,
      setCreatedAtEnd: setCreatedAtEnd,
      clearDate: setClearDate,
      clear: clearDate,
    },
  ]
  const onStatusFilterChanges = (name, status) => {
    const filterValue = status.length ? [status[status.length - 1]] : []

    if (name === 'Offer Raised') {
      setOfferRaisedFilter(filterValue)
    } else if (name === 'Offer Accepted') {
      setOfferAppliedFilter(filterValue)
    }
  }

  const permission = useSelector(state => state?.auth?.permissions)
  const subEvents = permittedSubEvents(
    permission,
    'REPORTS',
    'Applicants at Drive level'
  )
  return (
    <>
      {' '}
      <PageContent
        corporateName={corporateData?.name}
        columnWidths={[15, 25, 35, 43, 25, 15, 24, 40, 18, 23, 23]} // Array of column widths
        columnFontSize={10} // Font size for the column data
        HAlign={[
          'center',
          'center',
          'left',
          'left',
          'left',
          'center',
          'center',
          'left',

          'right',
          'left',
          'left',
        ]}
        setSearchDegree={setSearchDegree}
        filterData={FilterData}
        cityData={cityData}
        cityDetails={cityDetails}
        pageHeader="Applicants At Drive Level"
        hasProp={hasData(filterData)}
        column={columns}
        tableData={rolesPublishedData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        onPageChange={onPageChange}
        setSearchRoleValue={setRoleNameValue}
        searchRoleValue={roleNameValue}
        applyFilter={applyFilter}
        clearFilter={clearFilter}
        onChange={onSorting}
        width={'100'}
        loadingRole={loadingRole}
        loadingTier={loadingTier}
        tooltip={tooltip}
        handleHover={handleHover}
        clickedExcel={clickedExcel}
        excel={excel}
        isExcel={isExcel}
        setIsExcel={setIsExcel}
        excelLoading={excelLoading}
        createdAtStart={createdAtStart}
        createdAtEnd={createdAtEnd}
        setCreatedAtStart={setCreatedAtStart}
        setCreatedAtEnd={setCreatedAtEnd}
        onStatusFilterChanges={onStatusFilterChanges}
        setAppendDateFilter={setAppendDateFilter}
        appendDateFilter={appendDateFilter}
        clearDate={clearDate}
        setClearDate={setClearDate}
        clear={clear}
        setClear={setClear}
        error={error}
        setError={setError}
        dataSign={dataSign}
        treeData={degreeListData}
        setDegreeList={setDegreeList}
        degreeList={degreeList}
        filterCancel={filterCancel}
        setFilterCancel={setFilterCancel}
        loadingDep={loadingDep}
        degreeLoader={degreeLoader}
        setDateError={setDateError}
        loadMoreData={loadMoreData}
        pages={page}
        count={count}
        subEvents={subEvents}
      />
    </>
  )
}
export default ApplicationDriveStatus
